import React from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

import { fragment } from 'components/ListView/ListView'
import ScrollList from 'components/ScrollList/ScrollList'

import routeConfig from 'routeConfig'

import { QUERY_LIST_FAVORITES } from 'helpers/queries'

const queryPosts = gql`
  query Posts($first: Int!, $after: String, $in: [ID]) {
    posts(first: $first, after: $after, where: { in: $in }) {
      ...PostList
    }
  }
  ${fragment}
`

function useFavoritesList() {
  const { data } = useQuery(QUERY_LIST_FAVORITES)
  const favorites =
    data && data.listFavorites && data.listFavorites.length
      ? data.listFavorites
      : null
  const posts = useQuery(queryPosts, {
    variables: {
      first: 9,
      in: favorites && favorites.map(({ postId }) => postId)
    },
    skip: !favorites
  })
  return posts
}

const FavoritesList = () => {
  const { data } = useFavoritesList()
  const items = data
    ? data.posts.nodes.map(item => ({
        ...item,
        pathname: `${routeConfig.post}/${item.slug}`
      }))
    : null
  if (!items) {
    return null
  }
  return (
    <ScrollList
      items={items}
      title="Dine favoritter"
      to={routeConfig.mypageFavorites}
      backstate={{
        fromUrl: routeConfig.mypageFavorites,
        fromName: 'Favoritter'
      }}
    />
  )
}

export default FavoritesList
